/**
 * Clients Tab - Assessments
 */
import {
  FETCH_START,
  FETCH_ERROR,
  FETCH_SUCCESS,
  DB_CLIENT_SURVEYS,
  SURVEY_RESPONSES_BY_CLIENT,
  LIST_SURVEYS_FILTER_TAGS_CLIENT,
  DB_CLIENT_SURVEYS_NOT_FILTER,
} from "constants/ActionTypes"

import setupAxiosInterceptors from "appRedux/actions/setupAxiosInterceptors";

import axiosDB from 'util/ApiDB'
import ApiDBLimesurvey from 'util/ApiDBLimesurvey'

export const ActionAssessmentsListClients = (cid) => {
  return (dispatch, getState) => {
    dispatch({ type: FETCH_START })

    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);

    request.get('client/' + cid + '/surveys').then(({ data }) => {

      const client_surveys = data.response.surveys
      const templates = data.response.templates

      dispatch({
        type: DB_CLIENT_SURVEYS,
        payload: {
          client_surveys: client_surveys,
          client_templates: templates,
        }
      })

      dispatch({
        type: DB_CLIENT_SURVEYS_NOT_FILTER,
        payload: {
          client_surveys_not_filter: client_surveys,
        }
      })

      dispatch({ type: FETCH_SUCCESS })
    }).catch(function (error) {
      dispatch({ type: FETCH_ERROR, payload: error.message });
      console.log("Error****:", error.message);
    });

  }
}

export const ActionAssessmentsListClientsReset = () => {
  return (dispatch) => {
    dispatch({
      type: DB_CLIENT_SURVEYS,
      payload: {
        client_surveys: null,
      }
    })
  }
}


// Delete participant
export const ActionRemoteDeleteParticipant = (client_id, limesurvey_id, token_id) => {
  return (dispatch, getState) => {
    dispatch({ type: FETCH_START })

    const { limesurvey_session_key } = getState().authSurvey
    const request = setupAxiosInterceptors(ApiDBLimesurvey, dispatch, getState);

    request.post('delete-participant', {
      'sSessionKey': limesurvey_session_key,
      'iSurveyID': limesurvey_id,
      'tokenID': token_id,
      'cid': client_id
    }).then(({ data }) => {
      dispatch(ActionAssessmentsListClients(client_id))
    }).catch(function (error) {
      dispatch({ type: FETCH_ERROR, payload: error.message });
      console.log("Error****:", error.message);
    });
  }
}


export const ActionFilterSurveysByTag = (tag_ids, cid) => {
  return (dispatch, getState) => {

    
    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);

    if (tag_ids.length) {
      // Get tags by IDs
      request.post('survey/tags', {
        tag_ids: tag_ids
      }).then(({ data }) => {
        dispatch({
          type: LIST_SURVEYS_FILTER_TAGS_CLIENT,
          payload: {
            tags: data.response.tags
          }
        })
      }).catch(function (error) {
        dispatch({ type: FETCH_ERROR, payload: error.message });
        console.log("Error****:", error.message);
      });
    } else {
      dispatch({
        type: LIST_SURVEYS_FILTER_TAGS_CLIENT,
        payload: {
          tags: []
        }
      })
    }
  }
}


/*
export const ActionSaveClientSurvey = (client_survey, participant_properties) => {
  return (dispatch, getState) => {
    //console.log(client_survey, participant_properties)

    const requestDB = setupAxiosInterceptors(axiosDB, dispatch, getState);

    requestDB.post('survey/token/update-properties', {
      sid: client_survey.sid,
      token: client_survey.token,
      participant_properties: participant_properties
    }).then(({ data }) => {
      //console.log(data)
    }).catch(function (error) {
      dispatch({ type: FETCH_ERROR, payload: error.message });
      console.log("Error****:", error.message);
    });
  }
}
*/



export const ActionResetSurveyTokensByClient = () => {
  return (dispatch) => {
    dispatch({
      type: SURVEY_RESPONSES_BY_CLIENT, payload: {
        responses: null
      }
    })
  }
}